'use strict'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './StoreHeadline.scss'

class StoreHeadline extends PureComponent {
  render () {
    return (
      <div className='store-headline-wrapper'>
        <div className='store-icon'>
          <div className={'sl-map-icon sl-map-icon-detail sl-map-icon-type-' + this.props.type} />
          {
            this.props.clickandcollect &&
            <div className='sl-map-pointer sl-map-pointer-detail' />
          }
        </div>
        <div className='store-headline'>
          <h1 className='sh-title' tabIndex='0' itemProp='name'>{this.props.name}</h1>
          {
            this.props.distance !== null &&
            <p className='sh-distance' tabIndex='0'><span className='sr-only'>Distance: </span><span aria-hidden='true'>(</span>{this.props.distance} miles<span aria-hidden='true'>)</span></p>
          }
          <span className='hidden' itemProp='branchOf'>Argos</span>
        </div>
      </div>
    )
  }
}

StoreHeadline.defaultProps = {
  distance: null
}

StoreHeadline.propTypes = {
  name: PropTypes.string,
  type: PropTypes.number,
  distance: PropTypes.string,
  clickandcollect: PropTypes.bool
}

export default StoreHeadline



// WEBPACK FOOTER //
// ./src/components/Details/StoreHeadline/StoreHeadline.jsx